export enum AppointmentBusyStatus {
  Free = 0,
  Tentative = 1,
  Busy = 2,
  OutOfOffice = 3,
  WorkingElsewhere = 4,
  NoData = 5,
  Own = 6,
}

export enum AppointmentBusyStatusGraph {
  Free = "free",
  Tentative = "tentative",
  Busy = "busy",
  OutOfOffice = "outofoffice",
  WorkingElsewhere = "workingelsewhere",
  NoData = "nodata",
  Own = "own",
  Oof = "oof"
}
